import React from "react";

import "./style.css";

const ServicesBoxIcon = () => {
  return (
    <>
      {/* service area start */}
      <section className="nh_service-area pt-100 pb-70 nh_light_bg">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8">
              <div className="nh_section-area mb-40 text-center">
                <span className="nh_section-subtitle">Our services</span>
                <h2 className="nh_section-title mb-0">Explore Our Services</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-sm-6">
              <div className="nh_service-item mb-30">
                <div className="nh_service-item-icon">
                  <img src="images/mobile-recharge-icon.png" />
                </div>
                <div className="nh_service-item-content">
                  <h4 className="nh_service-item-content-title">
                    Mobile Recharge
                  </h4>
                  <p>
                    NexPe offers quick, secure mobile recharges for all major
                    telecom operators in India, ensuring seamless connectivity
                    anytime, anywhere.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-sm-6">
              <div className="nh_service-item mb-30">
                <div className="nh_service-item-icon">
                  <img src="images/dish-tv-icon.png" />
                </div>
                <div className="nh_service-item-content">
                  <h4 className="nh_service-item-content-title">
                    DTH Recharge
                  </h4>
                  <p>
                    NexPe provides fast and easy DTH recharges for all major
                    service providers, ensuring uninterrupted entertainment at
                    your convenience.
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="col-xl-4 col-lg-4 col-sm-6">
              <div className="nh_service-item mb-30">
                <div className="nh_service-item-icon">
                  <img src="images/google-play-icon.png" />
                </div>
                <div className="nh_service-item-content">
                  <h4 className="nh_service-item-content-title">
                    Google Play Recharge
                  </h4>
                  <p>
                    NexPe offers quick and secure Google Play recharges, giving
                    you instant access to apps, games, and more, anytime you
                    need.
                  </p>
                </div>
              </div>
            </div> */}
            {/* <div className="col-xl-3 col-lg-4 col-sm-6">
              <div className="nh_service-item mb-30">
                <div className="nh_service-item-icon">
                  <svg
                    width={40}
                    height={36}
                    viewBox="0 0 40 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M37.5948 0H2.40517C1.08152 0 0 1.08152 0 2.40517V32.8006C0 34.1243 1.08152 35.2058 2.40517 35.2058H37.5948C38.9185 35.2058 40 34.1243 40 32.8006V2.40517C40 1.08152 38.9185 0 37.5948 0ZM31.59 1.59806C32.4617 1.59806 33.1881 2.32446 33.1881 3.19613C33.1881 4.08394 32.4617 4.79419 31.59 4.79419C30.7183 4.79419 29.9919 4.0678 29.9919 3.19613C29.9919 2.32446 30.7183 1.59806 31.59 1.59806ZM27.1994 1.59806C28.071 1.59806 28.7974 2.32446 28.7974 3.19613C28.7974 4.08394 28.071 4.79419 27.1994 4.79419C26.3277 4.79419 25.6013 4.0678 25.6013 3.19613C25.6013 2.32446 26.3115 1.59806 27.1994 1.59806ZM37.5948 33.0751H2.40517V6.39225H37.5948V33.0751ZM35.9968 4.79419C35.1251 4.79419 34.3987 4.0678 34.3987 3.19613C34.3987 2.32446 35.1251 1.59806 35.9968 1.59806C36.8684 1.59806 37.5948 2.32446 37.5948 3.19613C37.5948 4.08394 36.8684 4.79419 35.9968 4.79419ZM14.8345 8.87813H27.1186V11.2026H14.8345V8.87813ZM19.6772 14.1889H35.222V16.4972H19.6772V14.1889ZM19.6772 18.8055H35.222V21.1138H19.6772V18.8055ZM19.6772 23.4867H35.222V25.795H19.6772V23.4867ZM4.60048 28.1033H35.2381V30.4116H4.60048V28.1033ZM4.60048 14.1889H15.5448V25.6013H4.60048V14.1889Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <div className="nh_service-item-content">
                  <h4 className="nh_service-item-content-title">
                    Utility Bill Payments
                  </h4>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipiscing elit .
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      {/* service area end */}
    </>
  );
};

export default ServicesBoxIcon;
